/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";
import { useConfirmAppointment } from "../../../hooks/useConfirmAppointment";
import { PageOverlayLoader } from "../../../../../../../../../shared/PageOverlayLoader/PageOverlayLoader";
import GfeToggle from "../../../../../../components/Gfe/GfeToggle";

export function Confirmation({ refetchAppointments }) {
  const { appointment, gfeToggle } = useContext();
  const confirmAppt = useConfirmAppointment();

  return (
    <div className="detail-row">
      <label>Appointment Confirmed:</label>
      <span>
        <label
          className="setting-switch pull-right"
          htmlFor="show_confirmed_toggle"
        >
          {appointment.isConfirmed ? (
            <span className="radioTextLabel">Yes</span>
          ) : (
            <span className="radioTextLabel">No</span>
          )}
          <input
            type="checkbox"
            name="show_confirmed_toggle"
            id="show_confirmed_toggle"
            checked={appointment.isConfirmed ? "checked" : 0}
            onChange={confirmAppt.toggle}
            disabled={confirmAppt.isLoading}
          />
          <span className="setting-slider width-45"></span>
        </label>
      </span>
      {gfeToggle.value !== null && (
        <GfeToggle refetchAppointments={refetchAppointments} />
      )}
      {confirmAppt.isLoading && <PageOverlayLoader />}
    </div>
  );
}
